import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-setting-save-error',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './setting-save-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./setting-save-error.component.scss'],
})
export class SettingSaveErrorComponent {
  constructor(private dialogRef: MatDialogRef<SettingSaveErrorComponent>) {}

  close(): void {
    this.dialogRef.close()
  }
}
